import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Page from "components/page/Page";
import Tabs from "components/tabs/Tabs";
import { Buildings } from "../buildings/Buildings";
import { Categories } from "../categories/Categories";
import { UnitTypes } from "../unitTypes/UnitTypes";
import { Units } from "../units/Units";
import { Amenities } from "../amenities/Amenities";

export function AccommodationConfiguration() {
  const history = useHistory<any>();
  const { t } = useTranslation();

  const { tab } = useParams<{ tab?: string }>();

  const tabs = [
    {
      id: "locations",
      content: t("Locations"),
    },
    {
      id: "categories",
      content: t("Categories"),
    },
    {
      id: "unit-types",
      content: t("Unit Types"),
    },
    {
      id: "units",
      content: t("Units"),
    },
    {
      id: "amenities",
      content: t("Amenities"),
    },
  ];

  const [selected, setSelected] = useState<number>(0);

  useEffect(() => {
    if (tab) {
      const tabIndex = tabs.findIndex(t => t.id === tab);
      if (tabIndex !== -1) {
        setSelected(tabIndex);
      }
    } else {
      const initialTab = history.location.state?.selectedTab ?? history.location.state?.params?.selectedTab;
      if (initialTab !== undefined) {
        setSelected(Number(initialTab));
        // Update URL to match state if provided
        history.replace(`/admin/accommodation/configuration/${tabs[Number(initialTab)].id}`);
      } else {
        // Default to first tab and update URL
        history.replace(`/admin/accommodation/configuration/${tabs[0].id}`);
      }
    }
  }, []);

  const handleTabChange = (selectedTabIndex: number) => {
    setSelected(selectedTabIndex);
    history.push(`/admin/accommodation/configuration/${tabs[selectedTabIndex].id}`);
  };

  return (
    <Page
      title={t("Property Configuration")}
      subtitle={t("View and manage your property configuration")}
      breadcrumbs={[
        { label: t("Accommodations"), url: "/admin/accommodation" },
        { label: t("Property Configuration"), url: "/admin/accommodation/configuration/locations" },
      ]}

      //   primaryAction={primaryAction}
    >
      <Page.Section>
        <div style={{ display: "flex", overflowX: "auto" }}>
          <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} />
        </div>
      </Page.Section>

      {selected === 0 ? (
        <div style={{ marginLeft: "-32px", marginRight: "-32px" }}>
          <Buildings />
        </div>
      ) : null}

      {selected === 1 ? (
        <div style={{ marginLeft: "-32px", marginRight: "-32px" }}>
          <Categories />
        </div>
      ) : null}

      {selected === 2 ? (
        <div style={{ marginLeft: "-32px", marginRight: "-32px" }}>
          <UnitTypes />
        </div>
      ) : null}

      {selected === 3 ? (
        <div style={{ marginLeft: "-32px", marginRight: "-32px" }}>
          <Units />
        </div>
      ) : null}

      {selected === 4 ? (
        <div style={{ marginLeft: "-32px", marginRight: "-32px" }}>
          <Amenities />
        </div>
      ) : null}
    </Page>
  );
}
